import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableCell, TableRow } from '@mui/material';
import { useClientFlagBag, useFlag, useSetFlag, } from '@zurich/common/featureFlags';
import { devError } from '@zurich/common/utils';
import { styled } from '../../../utils';
import { Select } from '../../Select';
import { Switch } from '../../Switch';
import { Tag } from '../../Tag/Tag';
import { Typography } from '../../Typography';
export function FeatureFlagEntry({ flagKey, title, description, tags, possibleValues, }) {
    const value = useFlag(flagKey);
    const clientFlagBag = useClientFlagBag();
    const isClientValue = flagKey in clientFlagBag;
    const setValue = useSetFlag(flagKey);
    if (typeof value !== 'boolean' &&
        (!possibleValues || possibleValues.length === 0)) {
        devError(`Invalid feature flag (${flagKey}): non-boolean but no possibleValues defined!`);
        return null;
    }
    return (_jsxs(TableRow, { children: [_jsxs(TableCell, { children: [_jsxs(TagsTypographyStyled, { variant: "h6", children: [_jsx("span", { children: title }), _jsx(Tag, { variant: isClientValue ? 'blue' : 'grey', children: isClientValue ? 'Manuell gesetzt' : 'Standardwert' })] }), description && _jsx(Typography, { variant: "body1", children: description }), tags && tags.length > 0 ? (_jsx(TagsTypographyStyled, { children: tags.map((tagName) => (_jsxs(Tag, { small: true, children: ["#", tagName] }, tagName))) })) : null] }), _jsx(TableCellMinWidth, { children: typeof value === 'boolean' ? (_jsx(Switch, { checked: value, 
                    // @ts-expect-error
                    onChange: (e) => setValue(e.target.checked) })) : (_jsx(Select, { options: possibleValues?.map((value) => ({
                        label: String(value),
                        value: value,
                    })) ?? [], value: value, onChange: (value) => {
                        if (value !== null) {
                            // @ts-expect-error
                            setValue(value);
                        }
                    } })) })] }));
}
const TableCellMinWidth = styled(TableCell)(() => ({
    minWidth: '150px',
}));
const TagsTypographyStyled = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));
